import { Mail, Phone, MapPin, Facebook, Linkedin, Twitter, Instagram } from 'lucide-react';

const FooterSv = () => {
  const navigationLinks = [{
    name: 'Hem',
    href: '/sv/'
  }, {
    name: 'Startup-resan',
    href: '/sv/startup-journey'
  }, {
    name: 'Rapporter',
    href: '/sv/reports'
  }];

  const sectorViewLinks = [{
    name: 'Startups',
    href: '/sv/startups'
  }, {
    name: 'Scale-ups',
    href: '/sv/scaleups'
  }];

  const thinkTankLinks = [{
    name: 'Vad vi gör',
    href: '/sv/insightlab/what-we-do'
  }, {
    name: 'Rådgivning',
    href: '/sv/insightlab/consultation'
  }, {
    name: 'Forskning',
    href: '/sv/insightlab/research'
  }, {
    name: 'Bidra',
    href: '/sv/insightlab/contribute'
  }, {
    name: 'Kalender',
    href: '/sv/calendar'
  }];

  const aboutLinks = [{
    name: 'Om SSN',
    href: '/sv/about'
  }, {
    name: 'Nyheter & Press',
    href: '/sv/newsroom'
  }, {
    name: 'Partners',
    href: '/sv/partners'
  }];

  const legalLinks = [{
    name: 'Användarvillkor',
    href: '/sv/terms'
  }, {
    name: 'Integritetspolicy',
    href: '/sv/privacy'
  }, {
    name: 'Cookie-policy',
    href: '/sv/cookies'
  }, {
    name: 'Tillgänglighet',
    href: '/sv/accessibility'
  }];

  const socialLinks = [{
    icon: Facebook,
    href: '#',
    label: 'Facebook'
  }, {
    icon: Linkedin,
    href: '#',
    label: 'LinkedIn'
  }, {
    icon: Twitter,
    href: '#',
    label: 'Twitter'
  }, {
    icon: Instagram,
    href: '#',
    label: 'Instagram'
  }];

  return (
    <footer className="text-white" style={{ backgroundColor: 'hsl(var(--brand-deep-blue))' }}>
      <div className="container mx-auto px-6 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 mb-12">
          {/* Contact Information - Takes 2 columns on large screens */}
          <div className="lg:col-span-2">
            <h3 className="text-white font-bold text-lg mb-6">Kontaktinformation</h3>

            <div className="space-y-4 mb-8">
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-cyan-400" />
                <a
                  href="mailto:contact@swedenstartupnation.se"
                  className="text-gray-300 hover:text-[#0066cc] transition-colors text-sm"
                >
                  contact@swedenstartupnation.se
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-cyan-400" />
                <a
                  href="tel:+46123456789"
                  className="text-gray-300 hover:text-[#0066cc] transition-colors text-sm"
                >
                  +46 123 456 789
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 mt-1 flex-shrink-0 text-cyan-400" />
                <div className="text-gray-300 text-sm">
                  <p>Combient Zenit</p>
                  <p>Vasagatan 12</p>
                  <p>111 20 Stockholm, Sverige</p>
                </div>
              </div>
            </div>

            {/* Social Links */}
            <div>
              <h4 className="text-white font-semibold mb-4">Följ oss</h4>
              <div className="flex space-x-3">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    className="w-10 h-10 bg-gray-700 rounded-lg flex items-center justify-center text-gray-400 hover:bg-[#0066cc] hover:text-[#030e30] transition-all duration-200"
                    aria-label={social.label}
                  >
                    <social.icon className="w-5 h-5" />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Navigation Links */}
          <div>
            <h3 className="text-white font-semibold mb-6">Navigation</h3>
            <ul className="space-y-3">
              {navigationLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-300 hover:text-[#0066cc] transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Sector View */}
          <div>
            <h3 className="text-white font-semibold mb-6">Sektorvy</h3>
            <ul className="space-y-3">
              {sectorViewLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-300 hover:text-[#0066cc] transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Think Tank */}
          <div>
            <h3 className="text-white font-semibold mb-6">Think Tank</h3>
            <ul className="space-y-3">
              {thinkTankLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-300 hover:text-[#0066cc] transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* About */}
          <div>
            <h3 className="text-white font-semibold mb-6">Om oss</h3>
            <ul className="space-y-3">
              {aboutLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-300 hover:text-[#0066cc] transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal & Policies */}
          <div>
            <h3 className="text-white font-semibold mb-6">Juridik & Policyer</h3>
            <ul className="space-y-3">
              {legalLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-300 hover:text-[#0066cc] transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom section with copyright */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2025 Sweden Startup Nation. Alla rättigheter förbehållna.
            </p>
            <p className="text-gray-500 text-xs">
              All data som visas kommer från vår betrodda, verifierade databas. När tredjepartsdata refereras anges källor tydligt tillsammans med informationen.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSv;
